import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useWalletDebitsV2 } from "./hooks/useWalletDebitsV2";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "walletDebitsReport.info.title",
  rows: [
    "walletDebitsReport.info.clinicWalletDebits",
    "walletDebitsReport.info.providerWalletDebits",
  ],
};

const WalletDebitsV2 = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useWalletDebitsV2(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicWalletDebits?.length;
  const isProviderDataEmpty = !isLoading && !data?.providerWalletDebits?.length;

  const providerData = useMemo(
    () =>
      data?.providerWalletDebits?.map((provider) => ({
        providerName: provider.provider_name,
        walletDebits: provider.total_wallet_debits,
      })) || [],
    [data],
  );

  const clinicData = useMemo(
    () =>
      data?.clinicWalletDebits?.map((clinic) => ({
        clinicName: clinic.clinic_name,
        walletDebits: clinic.total_wallet_debits,
      })) || [],
    [data],
  );

  const _clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Wallet Debits V2"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getWalletDebitsV2()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Wallet Debits", accessor: "walletDebits" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Wallet Debits", accessor: "walletDebits" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletDebitsV2;
